import { render, staticRenderFns } from "./Repass.vue?vue&type=template&id=0098f8ce&scoped=true&"
import script from "./Repass.vue?vue&type=script&lang=js&"
export * from "./Repass.vue?vue&type=script&lang=js&"
import style0 from "./Repass.vue?vue&type=style&index=0&id=0098f8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098f8ce",
  null
  
)

export default component.exports